import React, { useState } from "react";
import {useParams} from "react-router-dom";
import { getIn } from "formik";
import moment from "moment";
import 'moment/locale/id';
import Header from '../../components/Header/Header';
import { Badge, Accordion, Row, Col, Button, Table } from "react-bootstrap";
import { InfoCircleFill, Download } from "react-bootstrap-icons";
import styles from './SampleDataPage.module.css';
import DocumentPreviewModal from "./DocumentPreviewModal";

const ReviewSection = (props) => {
    moment.locale('id');
    const params = useParams();
    const { values, onSubmit } = props;

    const [previewModal, setPreviewModal] = useState(false);
    const [docIndex, setDocIndex] = useState();

    const openPdfDocumentPreview = (doc) => {
        const base64 = doc.dataUrl;

        const binStr = atob(base64.split(',')[1]);
        const len = binStr.length;
        const arr = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            arr[ i ] = binStr.charCodeAt( i );
        }

        const blob = new Blob([arr], {type: 'application/pdf'});
        const url = URL.createObjectURL(blob);
        let win = window.open("", "_blank");
        win.document.open();
        win.document.write('<iframe src="' + url + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
        win.document.close();
    }

    const onClickDocumentPreview = (doc) => {
        setDocIndex(values.documents.indexOf(doc));
        if (doc.file.type === 'application/pdf') {
            openPdfDocumentPreview(doc);
            return;
        }

        setPreviewModal(true);
    }

    return <>
        <Badge className={styles.codeBadge}>
            Kode Registrasi : {params.code}
        </Badge>
        <div className={`${styles.sectionCard} mt-3`}>
            <h3>Review</h3>
            <p>Pastikan data yang Anda masukkan sudah benar agar tim kami bisa segera memproses data Anda</p>
            <Row>
                <Col lg={12}>
                    <Accordion flush>
                        <Accordion.Item>
                            <Accordion.Header>Data Sampling</Accordion.Header>
                            <Accordion.Body className="p-0">
                                <div className={styles.infoArea}>
                                    <div className={styles.infoIconArea}>
                                        <InfoCircleFill className={styles.infoIcon}/>
                                    </div>
                                    <div>
                                        <p className="m-0">Setelah klik <b>Simpan</b>, data sampel wajib di-download & dibawa saat pengiriman sampel ke warehouse Segari</p>
                                    </div>
                                </div>
                                <div className="px-3 pt-3">
                                    Tanggal pengiriman: <br />
                                    <strong>{moment(values.deliveryTime).format('dddd, D MMMM YYYY')}</strong>
                                </div>
                                <div className="px-3 pt-3">
                                    Pengiriman ke: <br />
                                    <strong>{values.warehouseName}</strong> - {values.warehouseAddress}
                                </div>
                                <Row className="px-3 pt-3">
                                    <Col lg={12}>
                                        <Table striped bordered>
                                            <thead>
                                                <tr>
                                                    <th>Nama Sampel Barang</th>
                                                    <th>Qty</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {values.sampleItems.map((sample) =>
                                                    <tr>
                                                        <td>{sample.itemName}</td>
                                                        <td>
                                                            {sample.quantity} {sample.unit}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                    <Accordion flush>
                        <Accordion.Item>
                            <Accordion.Header>Upload Dokumen</Accordion.Header>
                            <Accordion.Body className="p-0">
                                <Row className="p-3">
                                    <Col lg={12}>
                                        <Table striped bordered>
                                            <thead>
                                                <tr>
                                                    <th>Nama Dokumen</th>
                                                    <th>Preview</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {values.documents
                                                    .filter(doc => doc)
                                                    .map((doc) =>
                                                    <tr>
                                                        <td>{doc.label}</td>
                                                        <td>
                                                            <a href="#" 
                                                            onClick={() => onClickDocumentPreview(doc)}>Lihat Dokumen</a>
                                                        </td>
                                                    </tr>
                                                )}
                                                <DocumentPreviewModal
                                                    {...previewModal} 
                                                    show={previewModal} 
                                                    onHide={() => setPreviewModal(false)} 
                                                    values={values} index={docIndex}
                                                />
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </Col>
            </Row>
        </div>
        <div className={'mt-5'} style={{width: '90%'}}>
            <Button type='submit' className={'float-end'} variant={"success"} onClick={() => onSubmit(values)}>
                Simpan
            </Button>
            <Button type={'button'} className={'float-end me-3'} variant={"outline-success"} onClick={props.back}>
                Kembali
            </Button>
        </div>
    </>
}

export default ReviewSection;